import React, {FC, useMemo} from 'react';

import {TeammateModel} from '../../../../../libs/shared/core/src/models/api/teammateModel';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {PermissionsEnum} from '../../../../models/api/roleModel';
import {TagModel} from '../../../../models/api/tagModel';
import {TagEditorBodyInitialState, TagEditorBodyPublicProps} from './tagEditorBody';
import {TagEditorDropdown} from './tagEditorDropdown';

/*
 * Props.
 */

interface CreateTagDropdownProps extends TagEditorBodyPublicProps, DropdownProps {
  userId: number;
  namespace: string;
  resourceNamespace?: string;
  initialName?: string;
  initialNamespace?: string;
  parentTag?: TagModel;
  hasPermission: (namespace: string, permission: PermissionsEnum) => boolean;
  teammates: ReadonlyArray<TeammateModel>;
  hasPreventPinTeamTags: boolean;
  height?: number;
}

/*
 * Component.
 */

export const CreateTagDropdown: FC<CreateTagDropdownProps> = (props) => {
  const {initialNamespace, initialName, parentTag} = props;

  const initialState = useMemo<TagEditorBodyInitialState>(
    () => ({
      name: initialName || '',
      namespace: initialNamespace || '',
      parentTags: (parentTag && [parentTag]) || [],
      showInWorkspaces: false,
      showInCells: false,
    }),
    [initialName, initialNamespace, parentTag],
  );

  return <TagEditorDropdown {...props} initialState={initialState} />;
};
